$(document).ready(function(){
  
  
  
//   sticky section
  
  
//    function sticky_relocate() {
//     var window_top = $(window).scrollTop();
//     var div_top = $('#sticky-anchor').offset().top;
//     if (window_top > div_top) {
//       $('#sticky').addClass('stick');
//     } else {
//       $('#sticky').removeClass('stick');
//     }
//   }

//   $(function() {
//     $(window).scroll(sticky_relocate);
//     sticky_relocate();
//   });
  

//   accordion js
  
  $(".inner-custom-acco li a").click(function(e){
    //e.preventDefault();
  	
    $(this).parent("li").siblings().find(".accordion-heading").removeClass("active");
    $(this).parent("li").siblings().find(".acc-content").removeClass("show-content");
    $(this).siblings(".acc-content").toggleClass("show-content");
    $(this).toggleClass("active");
  });
  
//   toggle menu 
  
  $(".hamburger-button").click(function(){
  	$(".mob-site-header").addClass("show-mob-site-menu");
    $("body").addClass("movewith-header");
  });
  $(".close-mob-site-header").click(function(){
  	$(".mob-site-header").removeClass("show-mob-site-menu");
    $("body").removeClass("movewith-header");
  });
  
  
  
  
//   address popup

  
//   $(".template-customers-addresses .grid__item ul li .address-edit-toggle").click(function(){
//   	$("body").addClass("overflow");
//   });
//   $(".cross button span").click(function(){
//   	$("body").removeClass("overflow");
//   });
//   $("#EditAddress_4682186293416 .address-edit-toggle").click(function(){
//   	$("body").removeClass("overflow");
//   });
  
   
  
//   about user js
  
  
  $('.wrap-user-with-content ul li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('.wrap-user-with-content ul li').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  })

    
//     equal height boxes js
    
    
//   var highestBox = 0;
//   $('.image-content-grid-boxes ul li .item').each(function(){  
//     if($(this).height() > highestBox){  
//       highestBox = $(this).height();  
//     }
//   });    
//   $('.image-content-grid-boxes ul li .item').height(highestBox);
  
  
//   var highestBox2 = 0;
//   $('.custom-collection ul li').each(function(){  
//     if($(this).height() > highestBox2){  
//       highestBox2 = $(this).height();  
//     }
//   });    
//   $('.custom-collection ul li').height(highestBox2);
  
  
  
  var highestBox3 = 0;
  $('.medium-up--one-quarter').each(function(){  
    if($(this).height() > highestBox3){  
      highestBox3 = $(this).height();  
    }
  });    
  $('.medium-up--one-quarter').height(highestBox3);
  
  
  
//   cart popup js
  
  
//   $(".shoping-cart-btn").hover(function(){
//   	$(".cart-popup").addClass("show-cart-popup");
//   });
//   $(".close-cart-popup").click(function(e){
//     e.preventDefault();
//   	$(".cart-popup").removeClass("show-cart-popup");
//   });
  
//   $(".home-banner .wrap-content form button a").click(function(){
//   	$(".cart-popup").addClass("show-cart-popup");
//   });
//   $(".cart-item .cart-btn .btn").click(function(){
//   	$(".cart-popup").addClass("show-cart-popup");
//   });
  
  
  
  
  
  
  
  
  
  
  
  
//   $(".shoping-cart-btn").hover(function(){
//   	$("body").addClass("iscartpopup");
//   });
  $("body").on("click",".close-cart-popup",function(){
  	$("body").removeClass("iscartpopup");
  });
  function getCart(callback) {
    $.ajax({
      type: 'GET', 
      url: '/cart.js', 
      dataType: 'json', 
      success: function(data){
      	callback(data);
      },
      error: function(){}
    });
  }
   function addItem(form,handle) {
    var text = $(handle).parent().find('.quick-view-add-to-cart a span').text();
    $(handle).parent().find('.quick-view-add-to-cart a span').text("Processing..");
    $(handle).parent().find('.quick-view-add-to-cart').attr("pointer-events","none");
     $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: $(form).serialize(),
        success: function(data){
          getCart(function(data){
            var cart = $('.shoping-cart-btn');
                  var imgtodrag = $(handle).parent().parent().parent().find("img").eq(0);
                  if (imgtodrag) {
                      var imgclone = imgtodrag.clone()
                          .offset({
                          top: imgtodrag.offset().top,
                          left: imgtodrag.offset().left
                      })
                          .css({
                          'opacity': '0.8',
                            'z-index':'9999999999999999',
                              'position': 'absolute',
                              'height': '150px',
                              'width': '150px',
                              'z-index': '100'
                      })
                          .appendTo($('body'))
                          .animate({
                          'top': cart.offset().top + 10,
                              'left': cart.offset().left + 10,
                              'width': 75,
                              'height': 75
                      }, 1000, 'easeInOutExpo');

          //             setTimeout(function () {
          //                 cart.effect("shake", {
          //                     times: 2
          //                 }, 200);
          //             }, 1500);

                      imgclone.animate({
                          'width': 0,
                              'height': 0
                      }, function () {
                          $(this).detach()
                      });
                  }
                $(handle).parent().find('.quick-view-add-to-cart-load').css('display','block');
            	$(handle).parent().find('.quick-view-add-to-cart a span').text('Added to cart');
            $(handle).parent().find('.quick-view-add-to-cart a').addClass('added-cart');
            
              setTimeout(function(){
                $('.cart_item_count').html(data.item_count).removeClass("hide");
            	 //$(handle).parent().find('.quick-view-add-to-cart a span').text(text);
              	 $(handle).parent().find('.quick-view-add-to-cart-load').css('display','none');
                 $(handle).parent().find('.quick-view-add-to-cart').attr("pointer-events","all");
                   $("body").addClass('iscartpopup');
                	ajaxCart.load();
                
              },1000);
          });
        },
        error: function(e){console.log(e);}
     });
  }
  $('body').on('click','.quick-view-add-to-cart',function(event){
	   	event.stopPropagation();
    	event.preventDefault();
    	addItem($(this).closest('form'),this);	
         
      
  			});
  $('body').on('click','#AddToCart',function(event){
    
    var $this = $(this);
    $this.find("span").text("Processing..");
    $this.attr("pointer-events","none");
    
    
	   	event.stopPropagation();
    	event.preventDefault();


      $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        async:false,
        dataType: 'json', 
        data: $("form[data-product-form]").serialize(),
        success: function(data){           
          $this.find("span").text("Added to cart..");            
      	
          setTimeout(function(){
                $this.find("span").text("Add to cart");             	
                $this.attr("pointer-events","all");
            	$this.parent().find("button").addClass("btn-custom");
            	$('.cart_item_count').html(data.item_count).removeClass("hide");
             	$("body").addClass('iscartpopup'); 
                getCart(function(daata){
                    $('.cart_item_count').html(daata.item_count).removeClass("hide");
                    ajaxCart.load();
                });
 				
            	
              },1000);
        }
      });
  });
});


// address popup

 $(document).ready(function(){       
            $("#CartDrawer").prependTo(".site-header");           
         //$(".edit_form").prependTo("#shopify-section-footer-new"); 
    });

